// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ytMu","footer":"styles_footer__3JJwr"};